import { RootState } from "../../redux";

export const selectAllICProjectsByAgent = (state: RootState) => state.agenticprojects.allICProjectsByAgent;
export const selectCurrentAgentICProject = (state: RootState) => state.agenticprojects.currentICProjectByAgent;
